import React from 'react'

import { SkeletonProducts } from 'modulesCommon/Skeleton/ProjectDetails'

import { useTopChartingProducts } from '../serviceHooks'
import { TopChartingProducts } from '../components'

export const TopChartingProductsContainer = () => {
  const { products, productsLoading } = useTopChartingProducts()

  if (!products.length && productsLoading) return <SkeletonProducts />

  if (products.length) return <TopChartingProducts products={products} />

  return null
}
